import { render, staticRenderFns } from "./outstockMaterial.vue?vue&type=template&id=671534de&scoped=true&"
import script from "./outstockMaterial.vue?vue&type=script&lang=js&"
export * from "./outstockMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671534de",
  null
  
)

export default component.exports